import script from "./PaymentDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDetailView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDetailView.vue?vue&type=style&index=0&id=7fb98fc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb98fc5"]])

export default __exports__